export type GradeVariant = 'bad' | 'medium' | 'good'

export const getGradeVariant = (grade: number): GradeVariant => {
  if (grade < 40) return 'bad'
  if (grade < 80) return 'medium'
  return 'good'
}
